import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const baseProps = {
  width: 3.5,
  height: 3.5,
  fill: '#2CB46B',
};

const IconBase = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="12" {...baseProps} />
    <rect x="2" y="16.5" {...baseProps} />
    <rect x="11" y="3" {...baseProps} />
    <rect x="11" y="7.5" {...baseProps} />
    <rect x="11" y="12" {...baseProps} />
    <rect x="11" y="16.5" {...baseProps} fill="#1A6A42" />
    <rect x="20" y="3" {...baseProps} fill="#1A6A42" />
    <rect x="6.5" y="7.5" {...baseProps} fill="#1A6A42" />
    <rect x="6.5" y="12" {...baseProps} />
    <rect x="6.5" y="16.5" {...baseProps} />
    <rect x="15.5" y="3" {...baseProps} />
    <rect x="15.5" y="7.5" {...baseProps} />
    <rect x="15.5" y="12" {...baseProps} />
    <rect x="15.5" y="16.5" {...baseProps} />
    <rect x="20" y="7.5" {...baseProps} />
    <rect x="24.5" y="7.5" {...baseProps} />
    <rect x="20" y="12" {...baseProps} />
    <rect x="20" y="16.5" {...baseProps} />
    <rect x="24.5" y="3" {...baseProps} />
    <rect x="24.5" y="12" {...baseProps} fill="#1A6A42" />
    <rect x="24.5" y="16.5" {...baseProps} />
    <rect x="6.5" y="3" {...baseProps} />
    <rect x="2" y="3" {...baseProps} />
    <rect x="2" y="7.5" {...baseProps} />
  </svg>,
  'StatusHistoryIcon'
);

export const StatusHistoryIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.box-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.line-fill': {
          color: theme.palette.status.success.main,
          stroke: theme.palette.status.success.main,
        },
      })}
    />
  );
};
